module.exports = __webpack_public_path__ + "static/media/16UNODC27.c84ef1d3.jpg";